import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { PosReasonSelectModalComponent } from './pos-reason-select-modal.component';



@NgModule({
  declarations: [PosReasonSelectModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule
  ]
})
export class PosReasonSelectModalModule { }
